import { connect } from 'react-redux';
import get from 'lodash/fp/get.js';
import getOr from 'lodash/fp/getOr.js';
import { getFormValues } from 'redux-form';
import ModelFormField from './ModelFormField.jsx';
import getFullyQualifiedFieldName from '#support/utility/form/getFullyQualifiedFieldName.js';
import { modelTypesByForm } from '#constants/models/modelTypes/index.js';

// TODO: considering updating the wrapper for
// the EnhancedField to cover the additional functionality added here

const mapStateToProps = (state, ownProps) => {
  const { item, field } = ownProps;

  // Return null state if field is undefined - component won't render
  if (!field) {
    return {
      visible: false,
      value: null,
      autofilled: false,
      fullyQualifiedName: null,
    };
  }

  const { name, form, autofiller } = field;
  const fullyQualifiedName = getFullyQualifiedFieldName(item, name);

  let autofilled = false;

  // If this field has autofiller get autofilled state from Redux
  if (form && autofiller && modelTypesByForm[form]) {
    const { makeFieldIsAutofilledSelector } = modelTypesByForm[form];
    const selectFieldIsAutofilled = makeFieldIsAutofilledSelector();
    autofilled = selectFieldIsAutofilled(state, { name });
  }

  // Model form visibility and value patterns
  const visible = !!get(fullyQualifiedName, getOr({}, `form[${form}].visibleFields`, state));
  const value = get(fullyQualifiedName, getFormValues(form)(state) || {});

  return {
    fullyQualifiedName,
    value,
    visible,
    autofilled,
  };
};

export default connect(mapStateToProps)(ModelFormField);
